<div *ngIf="{customerPortalUrl: customerPortalUrl$ | async} as data" class="recruitment-box">
  <div class="heading">{{ "label.Recruiting" | translate }}</div>
  <div class="paragraph">
    <p class="paragraph-p1">
      <svg-icon src="/assets/icons/greater-sign.svg" class="paragraph-p1__icon"></svg-icon>
      &nbsp;{{ 'label.RecruitingP1' | translate }}
    </p>
    <p class="paragraph-p2">
      <svg-icon src="/assets/icons/greater-sign.svg" class="paragraph-p2__icon"></svg-icon>
      &nbsp;{{ 'label.RecruitingP2' | translate }}
    </p>
  </div>
  <div class="company-registration">
    <a href="{{data.customerPortalUrl}}/customer/register"  target="_blank" class="company-registration__text">{{'label.CompanyRegistration' | translate}}</a>
  </div>
  <div class="login">
    <a href="{{data.customerPortalUrl}}/sign-in" target="_blank" class="login__link">{{ 'label.CompanyLogin' | translate }}</a>
  </div>
</div>
